import { useState, useEffect } from 'react';

interface Notification {
  id: string;
  name: string;
  action: string;
  location: string;
  time: string;
}

const notifications: Notification[] = [
  { id: '1', name: 'Sarah M.', action: 'just subscribed', location: 'Boston, MA', time: '2 minutes ago' },
  { id: '2', name: 'Michael K.', action: 'downloaded the visa guide', location: 'New York, NY', time: '5 minutes ago' },
  { id: '3', name: 'Jennifer L.', action: 'joined the community', location: 'Chicago, IL', time: '8 minutes ago' },
  { id: '4', name: 'David R.', action: 'just subscribed', location: 'San Francisco, CA', time: '12 minutes ago' },
  { id: '5', name: 'Emily T.', action: 'booked a consultation', location: 'Seattle, WA', time: '15 minutes ago' },
  { id: '6', name: 'Robert P.', action: 'just subscribed', location: 'Austin, TX', time: '18 minutes ago' },
];

export default function SocialProofBanner() {
  const [currentNotification, setCurrentNotification] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show first notification after 5 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(initialTimer);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    // Rotate notifications every 8 seconds
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentNotification((prev) => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 300);
    }, 8000);

    return () => clearInterval(interval);
  }, [isVisible]);

  const notification = notifications[currentNotification];

  return (
    <div
      className={`fixed bottom-6 left-6 bg-white rounded-lg shadow-lg p-4 max-w-sm z-40 transition-all duration-300 ${
        isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
      }`}
    >
      <div className="flex items-start space-x-3">
        <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
          <i className="ri-user-line text-teal-600"></i>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-900 font-medium">
            <span className="font-semibold">{notification.name}</span> {notification.action}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            <i className="ri-map-pin-line mr-1"></i>
            {notification.location} • {notification.time}
          </p>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
          aria-label="Close notification"
        >
          <i className="ri-close-line text-lg"></i>
        </button>
      </div>
    </div>
  );
}